import { toast, ToastContainer, ToastOptions, ToastPosition, TypeOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Function to trigger toast messages with type safety
export const showToast = (
  message: string,
  type: TypeOptions = "error", // "info" | "success" | "warning" | "error" | "default"
  options: ToastOptions = { autoClose: 2000 }
) => {
  toast(message, { ...options, type });
};

// Reusable ToastContainer with prop types
interface ToastWrapperProps {
  position?: ToastPosition;
  autoClose?: number;
}

export const ToastWrapper = ({
  position = "top-right",
  autoClose = 5000,
}: ToastWrapperProps) => {
  return <ToastContainer position={position} autoClose={autoClose} />;
};
